import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapActions, mapGetters } from 'vuex';
import { addPvNew } from '@/pages/micro-detail/utils/index';
export default {
  props: {},
  data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    bannerData: 'yy/bannerData',
    urlParams: 'url/urlParams'
  })), {}, {
    bannerHeight() {
      const winWidth = window.innerWidth;
      const {
        height = 0,
        width = 0,
        pic = ''
      } = this.bannerData;
      if ((height === 0 || width === 0) && pic) {
        return this.imgSizeHandle(pic, winWidth);
      }
      const imgHeight = Math.floor(winWidth * (height / width));
      return imgHeight;
    },
    isShowBanner() {
      const {
        xnryy = ''
      } = this.urlParams;
      const {
        pic = ''
      } = this.bannerData;
      return xnryy && pic;
    }
  }),
  mounted() {
    const {
      xnryy = ''
    } = this.urlParams;
    if (xnryy) {
      this.requireBanner();
    }
    addPvNew(['openscreen_v2_yy.show'], {});
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    requireBanner: 'yy/requireBanner'
  })), {}, {
    imgSizeHandle(pic, winWidth) {
      this.getImageSize(pic).then(res => {
        const {
          width = 0,
          height = 0
        } = res || {};
        const imgHeight = Math.floor(winWidth * (height / width));
        return imgHeight;
      });
    },
    // 获取图像原始宽高
    getImageSize(url) {
      return new Promise(resolve => {
        let img = document.createElement('img');
        img.src = url;
        img.onload = () => {
          // onload-加载完之后才能获取到图片宽高
          resolve({
            width: img.naturalWidth,
            height: img.naturalHeight
          });
        };
      });
    }
  })
};